export default "__VITE_ASSET__28518e5b__"